import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check, Hotel, TrendingUp } from "lucide-react";

export default function PartnerCTA() {
  const navigate = useNavigate();
  const plans = [
    { name: "Free", price: "₹0", leads: "5 leads/month", features: ["Basic profile", "Lead view", "Chat support"], color: "border-slate-200" },
    { name: "Silver", price: "₹999", leads: "Unlimited leads", features: ["Verified badge", "Priority placement", "Insights"], color: "border-slate-400" },
    { name: "Gold", price: "₹2,499", leads: "Unlimited + priority", features: ["Top placement", "Account manager", "Featured hotel"], color: "border-blue-600", featured: true },
    { name: "Premium", price: "₹4,999", leads: "Everything + leads boost", features: ["Hero placement", "API access", "Multi-property"], color: "border-slate-900" },
  ];

  return (
    <div className="bg-slate-50">
      <section className="bg-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8 grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="hw-label text-emerald-400">For hotels • Partner with us</div>
            <h1 className="hw-head text-5xl md:text-6xl font-black mt-3 leading-[0.95]">
              Bid. Win. Get paid<br/>directly.
            </h1>
            <p className="mt-5 text-slate-300 max-w-2xl leading-relaxed">
              No commissions. No price wars with OTAs. Just verified leads in your inbox.
              Submit quotes, negotiate, and convert empty inventory into revenue.
            </p>
            <Button onClick={() => navigate("/login")} data-testid="cta-list-hotel-btn" className="mt-7 bg-emerald-600 hover:bg-emerald-700 text-slate-900 rounded-sm font-bold px-7 py-6 h-auto text-base">
              List your hotel <Hotel className="ml-2 w-4 h-4" />
            </Button>
          </div>
          <div className="lg:col-span-5 grid grid-cols-3 gap-4">
            {[["0%", "Commission"], ["48h", "Setup"], ["12K+", "Leads"]].map(([n,l]) => (
              <div key={l} className="border border-blue-500/30 p-5">
                <div className="hw-head text-3xl font-black text-emerald-400">{n}</div>
                <div className="hw-label text-slate-300 mt-1">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 md:px-8 py-20">
        <div className="hw-label text-blue-700">Plans</div>
        <h2 className="hw-head text-4xl md:text-5xl font-black text-slate-900 mt-3">Simple, flat pricing</h2>
        <p className="text-slate-600 mt-3 max-w-xl">No booking commissions, ever. Switch or cancel anytime.</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {plans.map((p) => (
            <div key={p.name} className={`hw-card p-6 border-2 ${p.color} ${p.featured ? "hw-shadow-pop-amber" : ""}`}>
              <div className="flex items-start justify-between">
                <div className="hw-label text-slate-500">{p.name}</div>
                {p.featured && <span className="hw-chip bg-emerald-100 border-blue-500 text-emerald-800">Popular</span>}
              </div>
              <div className="hw-head text-4xl font-black text-slate-900 mt-3">{p.price}<span className="text-sm font-bold text-slate-500">/mo</span></div>
              <div className="text-sm text-slate-600 mt-1">{p.leads}</div>
              <ul className="mt-5 space-y-2">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-slate-700">
                    <Check className="w-4 h-4 text-emerald-600 shrink-0 mt-0.5" /> {f}
                  </li>
                ))}
              </ul>
              <Button onClick={() => navigate("/login")} className={`w-full mt-6 rounded-sm font-bold ${p.featured ? "bg-emerald-600 hover:bg-emerald-700 text-slate-900" : "bg-slate-900 hover:bg-slate-800 text-white"}`}>
                Get started
              </Button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
